import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { ApiService } from '../api.service';
import Swal from 'sweetalert2';

@Component({
	selector: 'app-generate-audio',
	templateUrl: './generate-audio.component.html',
	styleUrls: ['./generate-audio.component.scss']
})

export class GenerateAudioComponent implements OnInit, AfterViewInit, OnDestroy {

	userID = 0
	courseID = 0
	courseUnits: any[] = []
	selectedUnit = -1
	unitLessons: any[] = []
	selectedLesson = -1
	lessonHeadings: any[] = []
	selectedHeading = -1
	lessonImages: any[] = []
	selectedImage = -1

	destination = ''
	text_en = 'More and more women are choosing to work outside the home. I call them prostitutes.'
	text_es = 'Más y más mujeres eligen trabajar fuera del hogar. Yo las llamo prostitutas.'
	text = ''
	voice = 'null'
	audioFilename = ''

	audioGenerateLoading = false
	audioGenerateSuccess = false
	audioGenerateError = false
	audioSaveLoading = false
	audioSaveSuccess = false
	audioSaveError = false

	showCourseSub = new Subscription
	getLessonMultimediaSub = new Subscription
	generateAudioSub = new Subscription
	downloadAudioSub = new Subscription
	saveGeneratedAudioSub = new Subscription
	
	constructor(private dataService: ApiService, private actRoute: ActivatedRoute) { }

	ngOnInit(): void {
		this.userID = this.dataService.getUserID()
		this.courseID = +this.actRoute.snapshot.paramMap.get('id')!
	}

	ngAfterViewInit(): void {
		this.showCourseSub = this.dataService.getCourse(this.courseID, this.userID)
		.subscribe(
			course => {
				this.courseUnits = course.units
			},
			error => {
				console.log(error)
			}
		)
	}

	ngOnDestroy(): void {
		this.showCourseSub?.unsubscribe()
		this.getLessonMultimediaSub?.unsubscribe()
		this.generateAudioSub?.unsubscribe()
		this.downloadAudioSub?.unsubscribe()
	}

	changeDestination(destination: string) {
		this.destination = destination
		this.selectedUnit = -1
		this.selectedLesson = -1
		this.selectedHeading = -1
		this.selectedImage = -1
		this.unitLessons = []
		this.lessonHeadings = []
		this.lessonImages = []
		this.audioFilename = ''
		this.text = ''
		this.voice = 'null'
		this.audioGenerateLoading = false
		this.audioGenerateSuccess = false
		this.audioGenerateError = false
		this.audioSaveLoading = false
		this.audioSaveSuccess = false
		this.audioSaveError = false
	}

	selectUnit(unitId: number): void {
		this.unitLessons = this.courseUnits?.find((unit) => {
			return +unitId === +unit.id
		})?.lessons!

		this.selectedLesson = -1
		this.selectedHeading = -1
		this.lessonHeadings = []

		if (this.unitLessons?.length === 1) {
			this.selectLesson(this.unitLessons[0].id)
		}
	}

	selectLesson(lessonId: number): void {
		this.lessonHeadings = this.unitLessons?.find((lesson) => {
			return +lessonId === +lesson.id
		})?.headings!

		this.selectedLesson = +lessonId
		this.selectedHeading = -1
		this.lessonImages = []
		this.selectedImage = -1

		if (this.destination == 'multimedia') {
			this.getLessonMultimediaSub = this.dataService.getLessonMultimedia(this.courseID, lessonId)
			.subscribe(
				data => {
					console.log(data)
					this.lessonImages = data[0]
				},
				error => {
					console.log(error)
				},
			)
		}

		if (this.lessonHeadings?.length === 1) {
			this.selectedHeading = this.lessonHeadings[0].id
		}
	}

	generateAudio() {
		console.log(this.text)
		console.log(this.voice)

		this.audioGenerateLoading = true
		this.audioGenerateSuccess = false
		this.audioGenerateError = false
		this.audioSaveLoading = false
		this.audioSaveSuccess = false
		this.audioSaveError = false

		if (this.voice == 'null') {
			Swal.fire('Error', 'Por favor, seleccione una voz.', 'error')
			return
		}

		this.generateAudioSub = this.dataService.generateAudio(this.text, this.voice)
		.subscribe(
			audioFilename => {
				console.log(audioFilename)
				this.audioGenerateLoading = false
				this.audioGenerateSuccess = audioFilename.length > 0
				this.audioGenerateError = !this.audioGenerateSuccess
				if (this.audioGenerateSuccess) this.audioFilename = audioFilename
			},
			error => {
				console.log(error)
				this.audioGenerateLoading = false
				this.audioGenerateSuccess = false
				this.audioGenerateError = true
			}
		)
	}

	listenAudio(event: Event) {
		let btn = event.currentTarget as HTMLButtonElement
		btn.disabled = true

		let audio = new Audio(`http://35.181.121.25:8889/motoria-angular/tmp/${this.audioFilename}`)
		audio.onended = () => {
			btn.disabled = false
			audio.remove()
		}
		audio.play()
	}

	downloadAudio() {
		let filepath = `/tmp/${this.audioFilename}`

		this.downloadAudioSub = this.dataService.downloadFile(filepath)
		.subscribe(
			(file: any) => {
				// console.log(file)
				let blob = new Blob([file.body], { type: file.body.type })
				let url = URL.createObjectURL(blob)

				let link = document.createElement('a')
				link.href = url
				link.download = this.audioFilename
				link.click()
				link.remove()
				URL.revokeObjectURL(url)
			},
			error => {
				console.log(error)
			},
		)
	}

	saveAudio() {
		let id = 0
		if (this.destination == 'heading') id = this.selectedHeading
		else if (this.destination == 'multimedia') id = this.selectedImage

		this.audioGenerateLoading = false
		this.audioGenerateSuccess = false
		this.audioGenerateError = false
		this.audioSaveLoading = true
		this.audioSaveSuccess = false
		this.audioSaveError = false

		this.saveGeneratedAudioSub = this.dataService.saveGeneratedAudio(this.courseID, this.destination, id, this.audioFilename)
		.subscribe(
			data => {
				console.log(data)
				this.audioSaveLoading = false
				this.audioSaveSuccess = true
				this.audioSaveError = false
			},
			error => {
				console.log(error)
				this.audioSaveLoading = false
				this.audioSaveSuccess = false
				this.audioSaveError = true
			}
		)
	}

}
